import { createSelector } from 'reselect';
import type { Iterable } from 'immutable';

import type { State } from 'reducers';
import type { OrganizationState } from 'entities/organization/reducer';
import Organization from 'entities/organization/model';

export const selectOrganizationState = (state: State): OrganizationState =>
  state.get('entities').organization;

export const selectOrganizations = createSelector(selectOrganizationState, (organizationState) =>
  organizationState.get('organizations')
);

export const selectOrganizationByIdOrExternalId = createSelector(
  selectOrganizations,
  (_organizations, idOrExternalId: string) => idOrExternalId,
  (organizations, idOrExternalId: string) =>
    organizations.get(idOrExternalId) ||
    organizations.find(
      (organization: Organization) =>
        organization.externalId === idOrExternalId || organization.nonprofitId === idOrExternalId
    )
);

export const selectDisplayedOrganizations = createSelector(
  selectOrganizations,
  selectOrganizationState,
  (organizations, organizationState) =>
    organizationState
      .get('displayedOrganizationIds')
      .map((organizationId) => organizationId && organizations.get(organizationId))
      .filter(Boolean) as Iterable<string, Organization>
);
